function init() {
  var moreNode = document.querySelectorAll('#more')
  var scrollNode = moreNode[moreNode.length-1]
  scrollURL = scrollNode.querySelector('a').getAttribute("href");
  if (moreNode.length > 0 && scrollNode.style.display != 'none') {
    fetchProducts(scrollURL, scrollNode)
  }
}

function fetchProducts (scrollURL, scrollNode) {
  fetch(scrollURL)
  .then(response => {
    scrollNode.style.display = 'none'
    return response.text()
  })
  .then(data => appendProducts(data))
  .then(() => checkMoreProducts(scrollNode, scrollURL))
  .catch(err => console.log(err))
}

function appendProducts (data) {
 
  var referenceNode = document.getElementById('product-list-ancher');
  var parser = new DOMParser();
  var doc = parser.parseFromString(data, 'text/html');
  var newProducts = doc.body.querySelectorAll('.product')
  console.log(newProducts)
  for (const product of newProducts) {
    referenceNode.parentNode.insertBefore(product, referenceNode);
  }
  total_prod = document.getElementsByClassName('grid__item product').length;
  document.getElementById('products').innerHTML = total_prod;
  if(document.getElementById('more')){
    document.getElementById('more') ? document.getElementById('more').remove() : null;
  }
}

function checkMoreProducts (scrollNode, scrollURL) {
  var productItemsCount = document.querySelectorAll('#main-collection-product-grid > li').length
  var collectionCount = Number(document.getElementsByClassName('collection-product-count')[0].getAttribute('data-collection-count'))
  if (productItemsCount < collectionCount) {
    appendMoreLink(scrollNode, scrollURL)
  } 
}

function appendMoreLink (scrollNode, scrollURL) {
  urlArray = scrollURL.split('?page=')
  let newUrl = urlArray[0] + '?page=' + (parseInt(urlArray[1]) + 1)
  var scrollLink = scrollNode.cloneNode(true)
  scrollLink.style.display = 'block'
  scrollLink.querySelector('a').href = newUrl
  scrollLink.addEventListener('click', function(event){
    eventList(event)
  }, false)
  document.querySelector('#main-collection-product-grid').append(scrollLink)
}

function eventList (event) {
  event.stopPropagation()
  event.preventDefault()
  init();
}

document.querySelector('#more a').addEventListener('click', function(event){
  eventList(event)
}, false);